import { z } from 'zod';

const B2bContractTypeValues = [
  'soles',
  'es_custom',
  'er_standard',
  'er_custom',
  'er_external',
  'essentiel',
  'flexible',
  'patrimonial',
  'premium',
  'sur_mesure',
] as const;

export const ZodB2bContractType = z.enum(B2bContractTypeValues);

export type B2bContractType = z.TypeOf<typeof ZodB2bContractType>;
